import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HomepagelocalNigeriaService } from '../countryhomenigeria.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-local-trusted-way-section',
  templateUrl: './trusted-way-section.component.html',
  styleUrls: ['./trusted-way-section.component.scss'],
  imports: [CommonModule],
})
export class LocalTrustedWaySectionComponent implements OnInit {
  @Input() pageData:any;
  constructor(private homePageService: HomepagelocalNigeriaService) {}

  trustedWaySectionData: any;
  hasInside = true;
  ngOnInit(): void {
    this.hasInside = !this.pageData?.psProductVideo;
    if (!this.pageData?.psProductVideo && !this.pageData?.values) {
      this.hasInside = false;
    }
    const data = this.pageData?.customersStatsContentPanel?.fields;
    if (data) {
      this.trustedWaySectionData = {
        icons: data?.image,
        header: data?.title,
      };
    }
  }
  ngOnChanges(): void {
    this.hasInside = !this.pageData?.psProductVideo;
    const data = this.pageData?.customersStatsContentPanel?.fields;
    if (data) {
      this.trustedWaySectionData = {
        icons: data?.image,
        header: data?.title,
      };
    }
  }
}
